module.exports = __webpack_public_path__ + "img/facebook-icon.30a8b070.png";